module.exports = __webpack_public_path__ + "img/Feature.6977c067.png";